import React, { useEffect, useState } from 'react';
import { Box, Typography, Switch, TextField, FormControl, FormGroup, FormControlLabel, Checkbox, Button, Divider } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PlusCircle, ArrowLeft, User, ChevronLeft } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { authApi, formauthApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logout } from '../../features/auth/AuthSlice';
import Toastmessage from '../../components/Toast';


export default function AddUserRole() {
  const [active, setActive] = useState(false);
  const [roleName, setRoleName] = useState('');
  const [id, setId] = useState('');
  const [modules, setModules] = useState([])
  const [selectedPermissionIds, setSelectedPermissionIds] = React.useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsloading] = useState(false);

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  const location = useLocation();
  const { roleId } = location.state || {}; // Retrieve the ID

  const handleActiveChange = (event) => {
    setActive(event.target.checked);
  };

  const handleRoleNameChange = (event) => {
    setRoleName(event.target.value);
  };



  const handlePermissionChange = (e, moduleName, permission) => {
    const isChecked = e.target.checked;

    setSelectedPermissionIds((prevIds) => {
      if (isChecked) {
        // Add the permission ID if checked
        return [...prevIds, permission.permission_id];
      } else {
        // Remove the permission ID if unchecked
        return prevIds.filter((id) => id !== permission.permission_id);
      }
    });

    // Optionally update module permissions (if needed)
    // Update the permissions state here if required for UI
  };


  const validateForm = () => {
    const newErrors = {};

    // User Name validation: Required and must be at least 4 characters long
    if (!roleName || roleName.trim() === '') {
      newErrors.roleName = "Role name is required";
    } else if (roleName.length < 4) {
      newErrors.roleName = "Role name must be at least 4 characters long";
    }

    if (!selectedPermissionIds || selectedPermissionIds.length === 0) {
      newErrors.selectedPermissionIds = "At least one permission must be selected";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return; // Exit if validation fails
    }

    const addRollApi = async () => {
      setIsloading(true)
      const input_token = id+'UPDATE_ROLE';
      const apiUrl = 'update_role';

      const dataInput = {
        login_user_id: userID,
        role_name: roleName,
        role_id:id,
        permissions: selectedPermissionIds
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token, true);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setTimeout(() => navigate(-1), 2000);
        } else if (data && data.message === 'Token has expired') {
          setIsloading(false)
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          setIsloading(false)
          await Toastmessage('No response from server', false);
        } else {
          setIsloading(false)
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        setIsloading(false)
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    };

    addRollApi();
  };

  useEffect(() => {
    if(roleId){
      fetchModules()
      fetchRoleDetails(roleId)
    }
    
  }, [roleId])

  //  fertch Modules 
  const fetchModules = async () => {
    const input_token = 'ACCESS_MODULE'; // Replace with your actual token
    const apiUrl = 'get_module_and_permissions'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);
      if (data && data.success) {
        setModules(data.modules)
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };


    //  fertch Modules 
    const fetchRoleDetails = async (roleId) => {
      const input_token = roleId+'VIEW_ROLE'; // Replace with your actual token
      const apiUrl = 'view_role'; // Replace with the actual API endpoint
  
      const dataInput = {
        "login_user_id":userID,
        "id":roleId
      };
  
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);
        if (data && data.success) {
          // setModules(data.modules)
          setSelectedPermissionIds(data?.data?.permissionrole?.map(item => item.permission_id))
          setRoleName(data?.data?.role_name)
          setId(data?.data?.id)
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
  
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    };

  return (
    <Box>
      {/* Page Header */}
      <Box className="title_head"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="20px"
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: "12px", color: 'var(--icon-color)'}} />
          <Typography fontSize={12} color="var(--text-color)">
            Edit Role
          </Typography>
        </Box>

        {/* Right Section */}
        <Button
          variant="outlined"
          component={Link}
          to="/userrole"
          sx={{
            backgroundColor: 'var(--back-button)',
            color: "var(--back-color)",
            fontWeight: "bold",
            border: "none",
            padding: "10px 20px",
          }}
          startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
          style={{ textTransform: "none" }}
        >
          Back to User Role List
        </Button>
      </Box>

      {/* Main Content */}
      <Box className="card-box" p={3} sx={{ borderRadius: '8px', border: '1px solid var(--border-color)', m:3 }} >
        {/* Role Name */}
        <Grid container sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, md: 4 }}>
            <Typography sx={{ fontWeight: "500", color: "#595A63" }}>Role Name</Typography>
            <TextField
              placeholder="Enter the Role Name"
              fullWidth
              error={!!errors.roleName}
              helperText={errors.roleName}
              variant="outlined"
              InputProps={{
                sx: {
                  borderRadius: "8px",
                },
              }}
              value={roleName}
              onChange={handleRoleNameChange}
              sx={{ marginBottom: "24px" }}
            />
          </Grid>
        </Grid>

        {/* Modules Section */}
        {modules.map((module, index) => (
          <Box key={module.id} sx={{ marginBottom: "24px" }}>
            <FormControl component="fieldset" variant="standard">
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#595A63",
                  marginBottom: "8px",
                }}
              >
                {module.module_name}
              </Typography>
              <Box sx={{ marginLeft: "32px" }}>
                <FormGroup row>
                  {module.permissions.map((permission) => (
                    <FormControlLabel
                      key={permission.permission_id}
                      control={
                        <Checkbox
                          checked={selectedPermissionIds.includes(permission.permission_id)}
                          onChange={(e) =>
                            handlePermissionChange(e, module.module_name, permission)
                          }
                        />
                      }
                      sx={{
                        transform: "scale(0.8)",
                        borderRadius: "4px",
                        padding: "2px",
                        "&.Mui-checked": {
                          color: "#3570FF",
                        },
                      }}
                      label={permission.name}
                    />
                  ))}
                </FormGroup>
              </Box>
            </FormControl>
            {index < modules.length - 1 && <Divider sx={{ margin: "24px 0" }} />}
          </Box>
        ))}

        {errors.selectedPermissionIds && (
          <Typography variant="caption" color="error" sx={{ mt: 1 }}>
            {errors.selectedPermissionIds}
          </Typography>
        )}





        {/* Submit Button */}
        <Box sx={{ textAlign: "center", marginTop: "24px" }}>
          <Button
            type="submit"
            variant="contained"
            onClick={handleSubmit}
            disabled={isLoading}
            startIcon={<PlusCircle size={20} />}
             className='btn-theme-button'
          >
           Update Role
          </Button>
        </Box>
      </Box>
    </Box>

  );
}


